import {
  ListViewContextType,
  ListViewStateContextType,
  ListViewSubmitDataModel,
} from "../../context/ApplicationContext";
import { PlaceType } from "../fields/SmartAddressInput";
import {
  FieldConfiguration,
  FormPropertiesConfiguration,
} from "./form-configuration";

export interface FormSubmit {
  coi: string | null;
  request_id?: string;
  prgId?: number;
  form: Form;
}

export interface Form {
  id: string | undefined;
  uuid: string | undefined;
  name: string;
  sections: Section[];
}

export interface Section {
  id: string;
  fields?: Field[];
  type: string;
  forms?: Array<Form>;
}

export interface Field {
  id: string;
  name: string;
  value: string[];
}

export interface Tuple {
  id: string;
  value: string;
}

export const isPlaceType = (obj: any): obj is PlaceType => {
  return (
    obj != null &&
    typeof obj == "object" &&
    "structured_formatting" in obj &&
    "description" in obj
  );
};

export const placeTypeToString = (obj: PlaceType): string => {
  return obj.structured_formatting.main_text;
};

export const tupleArrayToStringArray = (obj: any): string[] => {
  if (!isTupleArray(obj)) throw new Error("Not Tuple Array");
  return Array.from(obj, (tuple: Tuple) => tuple.id);
};

export const isTupleArray = (obj: any): boolean => {
  if (!Array.isArray(obj)) return false;
  else {
    for (let i = 0; i < obj.length; i++) {
      if (!isTuple(obj[i])) return false;
    }
  }
  return true;
};

export const isTuple = (obj: any): obj is Tuple => {
  return obj != null && typeof obj == "object" && "id" in obj && "value" in obj;
};

const isJson = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const createForm = (
  data: any,
  formConfig: FormPropertiesConfiguration[],
  lstContext: ListViewStateContextType
): Form[] => {
  let formArray: Form[] = [];
  formConfig.forEach((formConfig: FormPropertiesConfiguration) => {
    let sections: Section[] = Array(formConfig.sections.length).fill({
      id: "",
      name: "",
      dbTable: "",
      fields: Array<Field>(),
    });

    for (let i = 0; i < formConfig.sections.length; i++) {
      sections[i] = {
        id: formConfig.sections[i].id,
        fields: undefined,
        type: formConfig.sections[i].type,
      };
      if (sections[i].type === "v") {

        const listView: ListViewContextType =
          lstContext.listViewsState[sections[i].id];
        sections[i].forms = listView
          ? listView.dataModel.submitRecordModel.map<Form>(
              (record: ListViewSubmitDataModel) => record.listItem
            )
          : [];
        // sections[i].forms = createForm(
        //   data,
        //   formConfig.sections[i].forms ?? [],
        //   lstContext
        // );
      } else {
        sections[i].fields = [];
        const keys: string[] = Object.keys(data);
        let fieldCount = 0;
        for (let j = 0; j < keys.length; j++) {
          const fieldConfArray: FieldConfiguration[] | undefined =
            formConfig.sections[i].fields;
          if (fieldConfArray) {
            const fieldConfiguration: FieldConfiguration | undefined =
              fieldConfArray.find((e: FieldConfiguration) => e.id === keys[j]);
            if (fieldConfiguration) {
              let value = isJson(data[keys[j]])
                ? JSON.parse(data[keys[j]])
                : data[keys[j]];

              if (fieldConfiguration.field_type === "phone")
                value = peerplacePhoneFormat(value);

              let sectionFields: Field[] | undefined = sections[i].fields;
              if (sectionFields && !isValueEmpty(value)) {
                sectionFields[fieldCount] = {
                  id: fieldConfiguration.id,
                  name: fieldConfiguration.name,
                  value: isTuple(value)
                    ? [value.id]
                    : isTupleArray(value)
                    ? tupleArrayToStringArray(value)
                    : isPlaceType(value)
                    ? [placeTypeToString(value)]
                    : [value],
                };

                fieldCount++;
              }
            }
          }
        }
      }
    }

    let form: Form = {
      id: formConfig.id,
      uuid: formConfig.uuid,
      name: formConfig.name,
      sections: sections,
    };


    formArray.push(form);
  });

  return formArray;
};

const isValueEmpty = (value: any): boolean => {
  if (isTuple(value) && (value.id == "" || value.id == undefined)) return true;
  if (
    isTupleArray(value) &&
    value.filter((tuple: Tuple) => tuple.id != "").length == 0
  )
    return true;
  if (value === "" || value === undefined || value == null) return true;
  return false;
};

const peerplacePhoneFormat = (input: string): string | undefined => {

  return input !== undefined
    ? input.slice(1, 4) + "-" + input.substring(6)
    : input;
};

export const transformFormData = (
  data: any,
  formConfig: FormPropertiesConfiguration,
  queryParams: URLSearchParams,
  lstContext: ListViewStateContextType
): FormSubmit => {
  let forms: Form[] = createForm(data, [formConfig], lstContext);

  let formSubmit: FormSubmit = {
    coi: queryParams.get("coi"),
    form: forms[0],
  };

  return formSubmit;
};
